const prev = '@base';

const CREATE_BASE = `${prev}/CREATE_BASE`;

export { CREATE_BASE };
